import React from 'react';
import I18n from 'app/i18n';
import PrizeCard from 'app/components/reusable/PrizeCard';
import {lootRarity} from 'app/utils/lootboxRarity';
import LootInterface from 'app/interfaces/LootInterface';

interface Props {
    items: LootInterface[]
}

const SetContents = ({items}: Props): React.ReactElement | null => {
    if (items.length === 0) {
        return null;
    }

    return <>
        <h3 className="shop-item-detail__section-title">{I18n.t('shop.set_contents_title')}</h3>
        <div className="prize-card-grid prize-card-grid--set">
            {items.map((item: LootInterface, index: number) => <PrizeCard
                key={`${lootRarity(item)}-${index}`}
                loot={item}
                hideMeta
            />)}
        </div>
    </>;
};

export default SetContents;
